export default __webpack_public_path__ + "static/Contact-365ac2edeff3cd7f2da9393688c95fe4.jpg";